// extracted by mini-css-extract-plugin
module.exports = {"alertButton":"styles_alertButton__vIxU1","text":"styles_text__runfK","icon":"styles_icon__8xKY6"};